import * as React from 'react';

interface IErrorPageProps {

}

interface IErrorPageState {

}

class ErrorPage extends React.Component<IErrorPageProps, IErrorPageState> {

    render(): any {
        return <div>ErrorPage</div>;
    }
}

export default ErrorPage;